export enum ProtocolId {
    Rest = 'rest',
    Graphql = 'graphql',
    Websocket = 'websocket',
}